var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CloPlaylist',{attrs:{"list":_vm.list,"title":_vm.title,"moreUrl":_vm.moreUrl,"mediaDownloadUrl":_vm.mediaDownloadUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }